"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createStringifiedTarget = exports.createFingerprints = void 0;
const crypto_1 = require("crypto");
const normalizeXpath_1 = require("./normalizeXpath");
const hash = (input) => (0, crypto_1.createHash)('sha256').update(input).digest('hex');
/**
 * Helper function to build the selector key for a given node
 * so we can easily check if it has been seen before or not (internal only)
 */
const buildSelectorKey = ({ ruleId, selector, url }) => {
    return `__${ruleId}_${url}__${JSON.stringify(selector)}`;
};
const createFingerprints = (params) => {
    const { ruleId, node } = params;
    if (!node.target) {
        throw new Error('createFingerprints: node.target is required to create fingerprints');
    }
    const selectorKey = (selector) => buildSelectorKey({
        ruleId,
        selector: selector,
        url: 'url' in params ? params.url : node.url
    });
    return [
        hash(selectorKey(node.target)),
        node.xpath && hash(selectorKey((0, normalizeXpath_1.normalizeXpath)(node.xpath))),
        node.ancestry && hash(selectorKey(node.ancestry))
    ].filter(Boolean);
};
exports.createFingerprints = createFingerprints;
// Backwards compatibility for walnut - Reusing CreateFingerprintsParams so we
// can easily delete this function once walnut is updated
const createStringifiedTarget = ({ ruleId, node, url }) => {
    if (!node.target) {
        throw new Error('createStringifiedTarget: node.target is required to create a stringified target');
    }
    return buildSelectorKey({
        ruleId,
        selector: node.target,
        url
    });
};
exports.createStringifiedTarget = createStringifiedTarget;
//# sourceMappingURL=createFingerprints.js.map